import stylesControllerMixin from '@/mixins/stylesControllerMixin'
import { mapMutations } from 'vuex'
import { tween, chain, delay, composite } from 'popmotion'
import { fillMap } from '@/util/sceneMap'

export default {
    mixins: [stylesControllerMixin],

    data() {
        return {
            hovered: false
        }
    },
    props: {
        i: {
            type: Number,
            default: 0
        }
    },

    computed: {
        stroke() {
            return this.scene === this.sceneId
                ? { stroke: '#F14F1D' }
                : { stroke: '#FFFFFF' }
        },
        strokeWidth() {
            return this.scene === this.sceneId
                ? { strokeWidth: 16 }
                : { strokeWidth: 4 }
        },
        fillOpacity() {
            if (this.scene === 'landing' || this.scene === 'intro') {
                return { fillOpacity: 0 }
            } else {
                let o = fillMap.get(this.sceneId)

                return this.hovered
                    ? { fillOpacity: 0.3 + o }
                    : { fillOpacity: o }
            }
        },

        styles() {
            return ['stroke', 'strokeWidth', 'fillOpacity']
        }
    },

    watch: {
        scene: {
            immediate: true,
            handler(scene) {
                if (scene === 'landing') {
                    this.styler.set({ pathLength: 0 })
                } else if (scene !== 'intro') {
                    this.styler.set({ pathLength: 100 })
                } else {
                    // this.styler.set({ pathLength: 50 })
                }
            }
        }
    },

    created() {
        this.element.addEventListener('click', this.clickHandler)
        this.element.addEventListener('mouseenter', this.hoverHandler)
        this.element.addEventListener('mouseleave', this.unhoverHandler)
    },

    beforeDestroy() {
        this.element.removeEventListener('click', this.clickHandler)
        this.element.removeEventListener('mouseenter', this.hoverHandler)
        this.element.removeEventListener('mouseleave', this.unhoverHandler)
    },

    methods: {
        ...mapMutations(['clickScene']),

        clickHandler() {
            this.clickScene(this.sceneId)
        },

        hoverHandler() {
            this.hovered = true
        },

        unhoverHandler() {
            this.hovered = false
        },

        action(to, from) {
            if (from.pathLength !== to.pathLength) {
                // to fix : multiple animations being started and overlapping
                return composite({
                    pathLength: chain(
                        delay(this.i * 200),
                        tween({
                            to: to.pathLength,
                            from: from.pathLength,
                            duration: 1000
                        })
                    ),
                    stroke: tween({ to: to.stroke, from: from.stroke }),
                    strokeWidth: tween({
                        to: to.strokeWidth,
                        from: from.strokeWidth
                    })
                })
            } else {
                return tween({ to, from })
            }
        }
    }
}
